import { View } from 'es6/components/view'
import { Defaults } from 'es-decorators'

/**
 * Вид для оверлея.
 */

@Defaults({
  el: '.overlay-blue',

  events: {
    'click': 'overlayClose',
  },
})
export class OverlayView extends View {
  /**
   * Закрытие оверлея.
   */
  overlayClose () {
    this.trigger('overlayClose')
  }
}
